import { ImageBlock } from 'components/general/imageBlock/ImageBlock';
import { Link } from 'components/link/Link';
import { ImageType } from 'pages/project/[id]';
import style from './StaffmemberCard.module.scss';

export type StaffMemberCardType = {
  name: string;
  position: string;
  image: ImageType;
  slug: string;
};
export const StaffMemberCard = ({
  name,
  position,
  slug,
  image: img,
}: StaffMemberCardType): JSX.Element => {
  return (
    // <Link href={slug}>
    //   <a className={style.linkWrapper}>
    <div className={style.container}>
      {/* <div className={style.imageContainer}> */}
      <div className={style.image}>
        <ImageBlock
          desktop={{
            src: img.image,
            layout: 'responsive',
            // layout: 'fill',
            // objectFit: 'cover',
            width: img.image_width,
            height: img.image_height,
          }}
          alt={img.alt_text}
        />
      </div>
      <div className={style.copyContainer}>
        <p className={style.title}>{name}</p>
        <p>{position}</p>
      </div>
      {/* </div> */}
    </div>
    //   </a>
    // </Link>
  );
};
